// extracted by mini-css-extract-plugin
export default {"sidebar":"User_sidebar__Rgrqg","logout":"User_logout__6yi9Y","content":"User_content__JwAha","wrapper":"User_wrapper__Vmb9v"};